import store from "@/store";

export const setClaroId = (query: object): void => {
  if (query && !store.getters.origin) {
    let amountUrl = "";
    Object.keys(query).forEach((value) => {
      if (amountUrl === "") {
        amountUrl += `${value}=${query[value]}`;
      } else {
        amountUrl += `&${value}=${query[value]}`;
      }

      if (value === "utm_campaign") {
        store.dispatch("setId", query[value]);
      }

      if (value === "gclid") {
        store.dispatch("setId", query[value]);
      }
    });

    if (amountUrl !== "") {
      store.dispatch("setOrigin", amountUrl);
    } else {
      store.dispatch("setOrigin", "");
      store.dispatch("setId", "");
    }

    return;
  }

  if (!store.getters.origin) {
    store.dispatch("setOrigin", "");
    store.dispatch("setId", "");
  }
};
